import '@smartsteuer/sui-sheets/dist/sheets'
import $ from 'jquery'

import './accordion'
import './global'
import './header'
import './split'
import './swiper'

window.$ = $
window.jQuery = $
